import React, { Component } from "react";
import "./ServiceGroup-modal.css";
const ServiceGroupModal = ({
  showModal,
  onCloseModalClick,
  serviceGroupName,
  handleChangeOrder,
  handleChangeName,
  orderNumber,
  maxRow,
  title,
  onFormClick,
}) => {
  const onFormCancel = () => {
    onCloseModalClick();
  };
  return (
    <div className={`modal  ${showModal ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
          </div>
          <div className="modal-body">
            <div className="row client-form">
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control form-input"
                  id="name"
                  name="name"
                  value={serviceGroupName}
                  onChange={handleChangeName}
                />
              </div>
            </div>
            <div className="row client-form">
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Order number
                </label>
                <input
                  type="number"
                  name="displayOrderNumber"
                  value={orderNumber}
                  min="1"
                  max={maxRow}
                  onChange={handleChangeOrder}
                  className="form-control form-input"
                />
              </div>
            </div>

            <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
              <button
                type="submit"
                className="btn btn-secondary me-2"
                onClick={() => onFormCancel()}
              >
                Cancel
              </button>{" "}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => onFormClick(e)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceGroupModal;
